module.exports = __webpack_public_path__ + "static/media/xz09_grey.6255f4e6.png";